import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReportAPI } from "../api/report";
import Loader from "../componets/Loader";
import ReportLogo from "../assets/SVGs/Report/ReportLogo";
import { formatCurrency } from "../componets/helper";
import { IconButton } from "@mui/material";
import PrintReport from "../assets/SVGs/Report/PrintReport";

const OverallActivityReport = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetch = async () => {
    setIsLoading(true);
    try {
      const storedValue = localStorage?.getItem("overallActivityReport");
      const startDate =
        storedValue === "all"
          ? "0001-01-01"
          : dayjs(storedValue).format("YYYY-MM-DD");
      const endDate = dayjs()?.format("YYYY-MM-DD");

      const closedBusinessData = await ReportAPI.getOverallActivityReport(
        startDate,
        endDate,
      );
      setData(closedBusinessData?.data);
    } catch (error) {
      const status = error.response?.status;
      if (status === 401) {
        navigate("/login");
      } else {
        console.error("Error fetching closed business report:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return isLoading ? (
    <Loader height="100vh" />
  ) : (
    <div className="report-section flex flex-col gap-16">
      <header className="report-header flex align-center justify-between flex-col gap-16">
        <ReportLogo width={122} height={50} />
        <div className="header-section flex align-center justify-between flex-col">
          <h1 className="header-title">Overall Activity Report</h1>
          <p className="header-date">
            {`${(() => {
              const storedDate = localStorage.getItem("overallActivityReport");

              if (storedDate === "all") {
                return `All Time - ${dayjs().format("MM/DD/YYYY")}`;
              }

              const formattedStartDate = dayjs(storedDate).isValid()
                ? dayjs(storedDate).format("MM/DD/YYYY")
                : "N/A";

              return `${formattedStartDate} - ${dayjs().format("MM/DD/YYYY")}`;
            })()}`}
          </p>
        </div>
        <IconButton
          sx={{
            border: "1px solid #AEBBCB",
            "@media print": {
              display: "none",
            },
          }}
          onClick={handlePrint}
          className="no-print"
        >
          <PrintReport className="no-print" />
        </IconButton>
      </header>
      <section className="customTable active-member-roster-table">
        <table>
          <thead>
            <tr>
              <th>Closed Business Count</th>
              <th>Referrals Given Count</th>
              <th>Total Meetups Count</th>
              <th>Total Revenue</th>
              <th>Total Visitors Count</th>
            </tr>
          </thead>
          <tbody>
            {!data ? (
              <tr>
                <td colSpan={5} style={{ textAlign: "center" }}>
                  No data available
                </td>
              </tr>
            ) : (
              <tr>
                <td>{data.closed_business_count}</td>
                <td>{data.referrals_given_count}</td>
                <td>{data.total_meetups_count}</td>
                <td>{formatCurrency(data.total_revenue)}</td>
                <td>{data.total_visitors_count}</td>
              </tr>
            )}
          </tbody>
        </table>
      </section>
    </div>
  );
};

export default OverallActivityReport;
